import { DateTime } from "luxon";
import { BaseService } from "./BaseService";

export class UserManageService extends BaseService {
  constructor() {
    super("/admin/users");
  }

  async findByUsername(username) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl}/${username}/find-by-username`
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async enable(userId) {
    try {
      const response = await this.getClient().patch(
        `${this.baseUrl}/${userId}/enable`
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async disable(userId) {
    try {
      const response = await this.getClient().delete(
        `${this.baseUrl}/${userId}/disable`
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async block(username, reason, days) {
    try {
      const blockedUntil = DateTime.utc().plus({ days }).toISO(); // Get UTC date and add days
      const response = await this.getClient().patch(
        `${this.baseUrl}/${username}/block`,
        { blockedUntil, reason }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async unblock(username, blockId) {
    console.log("blockId", blockId);
    try {
      const response = await this.getClient().patch(
        `${this.baseUrl}/${username}/unblock`,
        { blockId }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async toggleAllUsersStatus(active) {
    try {
      const response = await this.getClient().patch(
        `${this.baseUrl}/toggle-all-status`,
        { active }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getAllBlockedUsers(page = 1, limit = 10) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl}/blocked/all`,
        { params: { page, limit } }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}
